'use client'
import * as React from 'react'
import { createPortal } from 'react-dom'

type Props = {
  id?: string
  attachTo?: string
  className?: string
  onMount?: () => void
  enabled?: boolean
  children?: React.ReactNode
  disablePortal?: boolean
}

export const Portal = ({
  children,
  id = 'bshb-portal',
  attachTo,
  className,
  enabled = true,
  onMount,
  disablePortal,
}: Props) => {
  const [element, setElement] = React.useState<HTMLElement>()

  React.useEffect(() => {
    if (!enabled) return

    const getElement = () => {
      let portal: HTMLElement | undefined = undefined
      const existingPortal =
        document.getElementById(id) ??
        (attachTo ? document.querySelector(attachTo) : null)
      if (existingPortal) {
        portal = existingPortal
        if (className) {
          portal.classList.add(...className.split(' '))
        }
      } else {
        portal = document.createElement('div')
        portal.id = id
        if (className) {
          portal.classList.add(...className.split(' '))
        }
        document.body.appendChild(portal)
      }
      return portal
    }

    setElement(getElement())
  }, [className, id, enabled, attachTo])

  React.useEffect(() => {
    if (element && onMount) onMount()
  }, [onMount, element])

  if (disablePortal) return children

  // @ts-ignore children type should match
  return element ? createPortal(children, element) : null
}
